export default "__VITE_ASSET__b4f19cb7__"